import React from "react"
import PropTypes from "prop-types"
import Loader from "@irati/ui/src/Loading/Loader"
import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import {Body, H1} from "@irati/ui/src/Typography"
import getCurrency from "@irati/deals/helpers/deals/currency"
import LimitWrapper from "./LimitWrapper"
import QuantityContainer from "./Quantity/QuantityContainer"
import SagaStep from "./SagaStep"

const MultipleVoucherSelection = (
  {handleClick, isLoading, deal, products, willReachMax}
) => (
  <div className="multipleProductSelection">
    <SagaStep />
    <H1 marginBottom={2}><FormattedMessage id="perks.components.productForms.multipleProductSelection.selectText" /></H1>

    <div className="quantityList">
      {isLoading &&
      <>
        <Body>
          <FormattedMessage id="perks.components.productForms.multipleProductSelection.loading" />
        </Body>
        <Loader />
      </>}
      {!isLoading &&
        <LimitWrapper willReachMax={willReachMax} deal={deal} products={products} currency={getCurrency(deal)}>
          <QuantityContainer deal={deal} products={products} handleClick={handleClick} />
        </LimitWrapper>
      }
    </div>
  </div>
)
MultipleVoucherSelection.defaultProps = {
  willReachMax: false
}
MultipleVoucherSelection.propTypes = {
  handleClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  deal: PropTypes.object.isRequired,
  products: PropTypes.array.isRequired,
  willReachMax: PropTypes.bool
}

export default injectIntl(MultipleVoucherSelection)
